























import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
// import listenNative from "@/jsbridge/service/listenNative";
import AppLifeCycle from "@/utils/app_lifecycle/app_lifecycle";

import { isIos } from "@/utils/lodash";
@Component({
  components: {}
})
export default class VideoPlayer extends Vue {
  @Prop({ default: "" })
  private poster?: any;
  @Prop({ default: "" })
  private videoSrc?: any;
  @Prop({
    default: () => {
      return {};
    }
  })
  private videoStyle?: any;
  @Prop({
    default: () => {
      return {};
    }
  })
  private boxStyle?: any;
  @Prop({ default: true })
  private needLoop?: any;
  @Prop({ default: true })
  private autoplay?: any;

  private videoReady: any = isIos();
  private domReady: any = false;
  private foregroundListener: any = null;

  get wrappeStyle() {
    return {
      backgroundImage: `url(${this.poster})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: "100%"
    };
  }

  @Emit("ended")
  private endedEmit() {
    // console.log("endedEmit ended");
  }

  private addCountDownListener() {
    if (!this.foregroundListener) {
      this.foregroundListener = AppLifeCycle.addFrontListener(() => {
        setTimeout(() => {
          this.playVedio();
        }, 1000);
      });
    }
  }

  private playVedio() {
    this.$nextTick(() => {
      const videoRef: any = this.$refs.videoRef;
      try {
        const playPromise = videoRef && videoRef.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Automatic playback started!
              console.log("playPromise success");
            })
            .catch((error: any) => {
              console.log("playPromise", error);
              // Auto-play was prevented
            });
        }
      } catch (error) {
        // (Error as any).catchErrorManually(error);
        return Promise.reject(error);
      }
    });
  }

  private removeCountDownListener() {
    if (this.foregroundListener !== null) {
      AppLifeCycle.removeListener(this.foregroundListener);
    }
  }

  private beforeDestroy() {
    this.removeCountDownListener();
  }

  private deactivated() {
    this.domReady = false;
    this.removeCountDownListener();
  }

  private activated() {
    console.log("activated");
    this.playVedio();
    this.$nextTick(() => {
      setTimeout(() => {
        this.domReady = true;
      }, 100);
    });
    this.addCountDownListener();
  }

  private mounted() {
    console.log("mounted");
    this.addCountDownListener();
    this.$nextTick(() => {
      this.domReady = true;
      const videoRef: any = this.$refs.videoRef;
      videoRef &&
        videoRef.addEventListener("canplaythrough", () => {
          console.log("canplaythrough:", videoRef.currentTime);
          this.videoReady = true;
          this.$emit("videoReady");
        });
    });
  }
}
